import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HeaderComponentBase } from './header.component.base';

@Component({
	selector: 'bas-nav-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		'[class.logged-in]': 'showMainNav()',
	},
	standalone: false,
})
export class HeaderComponent extends HeaderComponentBase {
}
